import { render, staticRenderFns } from "./LoginFromGame.vue?vue&type=template&id=727bf9de&scoped=true"
import script from "./LoginFromGame.vue?vue&type=script&lang=js"
export * from "./LoginFromGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727bf9de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('727bf9de')) {
      api.createRecord('727bf9de', component.options)
    } else {
      api.reload('727bf9de', component.options)
    }
    module.hot.accept("./LoginFromGame.vue?vue&type=template&id=727bf9de&scoped=true", function () {
      api.rerender('727bf9de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/loginModal/LoginFromGame.vue"
export default component.exports